var map = {
	"./10_4_0.png": 36,
	"./10_4_1.png": 37,
	"./11_1_0.png": 38,
	"./11_1_1.png": 39,
	"./12_3_0.png": 40,
	"./13_4_0.png": 41,
	"./14_1_0.png": 42,
	"./14_1_1.png": 43,
	"./15_2_0.png": 44,
	"./16_4_0.png": 45,
	"./17_2_0.png": 46,
	"./18_4_0.png": 47,
	"./19_1_0.png": 48,
	"./19_1_1.png": 49,
	"./19_1_2.png": 50,
	"./19_1_3.png": 51,
	"./1_1_0.png": 52,
	"./1_1_1.png": 53,
	"./1_1_2.png": 54,
	"./1_1_3.png": 55,
	"./1_1_4.png": 56,
	"./1_1_5.png": 57,
	"./20_1_0.png": 58,
	"./20_1_1.png": 59,
	"./20_1_2.png": 60,
	"./20_1_3.png": 61,
	"./20_1_4.png": 62,
	"./21_3_0.png": 63,
	"./21_3_1.png": 64,
	"./21_3_2.png": 65,
	"./22_1_0.png": 66,
	"./22_1_1.png": 67,
	"./22_1_2.png": 68,
	"./22_1_3.png": 69,
	"./23_1_0.png": 70,
	"./23_1_1.png": 71,
	"./23_1_2.png": 72,
	"./23_1_3.png": 73,
	"./24_2_0.png": 74,
	"./24_2_1.png": 75,
	"./25_2_0.png": 76,
	"./25_2_1.png": 77,
	"./25_2_2.png": 78,
	"./26_4_0.png": 79,
	"./26_4_1.png": 80,
	"./26_4_2.png": 81,
	"./27_2_0.png": 82,
	"./27_2_1.png": 83,
	"./27_2_2.png": 84,
	"./27_2_3.png": 85,
	"./27_2_4.png": 86,
	"./28_4_0.png": 87,
	"./28_4_1.png": 88,
	"./28_4_2.png": 89,
	"./28_4_3.png": 90,
	"./29_2_0.png": 91,
	"./29_2_1.png": 92,
	"./2_4_0.png": 93,
	"./30_3_0.png": 94,
	"./30_3_1.png": 95,
	"./31_2_0.png": 96,
	"./31_2_1.png": 97,
	"./31_2_2.png": 98,
	"./32_3_0.png": 99,
	"./33_3_0.png": 100,
	"./33_3_1.png": 101,
	"./34_3_0.png": 102,
	"./35_3_0.png": 103,
	"./35_3_1.png": 104,
	"./36_4_0.png": 105,
	"./36_4_1.png": 106,
	"./36_4_2.png": 107,
	"./37_4_0.png": 108,
	"./38_4_0.png": 109,
	"./38_4_1.png": 110,
	"./38_4_2.png": 111,
	"./38_4_3.png": 112,
	"./39_1_0.png": 113,
	"./39_1_1.png": 114,
	"./39_1_2.png": 115,
	"./39_1_3.png": 116,
	"./39_1_4.png": 117,
	"./3_1_0.png": 118,
	"./3_1_1.png": 119,
	"./3_1_2.png": 120,
	"./3_1_3.png": 121,
	"./40_2_0.png": 122,
	"./41_3_0.png": 123,
	"./42_4_0.png": 124,
	"./42_4_1.png": 125,
	"./43_2_0.png": 126,
	"./43_2_1.png": 127,
	"./43_2_2.png": 128,
	"./43_2_3.png": 129,
	"./44_3_0.png": 130,
	"./44_3_1.png": 131,
	"./45_4_0.png": 132,
	"./45_4_1.png": 133,
	"./46_2_0.png": 134,
	"./46_2_1.png": 135,
	"./46_2_2.png": 136,
	"./47_3_0.png": 137,
	"./47_3_1.png": 138,
	"./47_3_2.png": 139,
	"./48_4_0.png": 140,
	"./49_1_0.png": 141,
	"./49_1_1.png": 142,
	"./49_1_2.png": 143,
	"./49_1_3.png": 144,
	"./49_1_4.png": 145,
	"./4_3_0.png": 146,
	"./50_3_0.png": 147,
	"./50_3_1.png": 148,
	"./51_4_0.png": 149,
	"./51_4_1.png": 150,
	"./52_1_0.png": 151,
	"./52_1_1.png": 152,
	"./52_1_2.png": 153,
	"./52_1_3.png": 154,
	"./52_1_4.png": 155,
	"./53_3_0.png": 156,
	"./53_3_1.png": 157,
	"./54_4_0.png": 158,
	"./55_1_0.png": 159,
	"./55_1_1.png": 160,
	"./55_1_2.png": 161,
	"./55_1_3.png": 162,
	"./55_1_4.png": 163,
	"./56_3_0.png": 164,
	"./56_3_1.png": 165,
	"./57_4_0.png": 166,
	"./57_4_1.png": 167,
	"./5_1_0.png": 168,
	"./5_1_1.png": 169,
	"./5_1_2.png": 170,
	"./5_1_3.png": 171,
	"./5_1_4.png": 172,
	"./5_1_5.png": 173,
	"./6_4_0.png": 174,
	"./6_4_1.png": 175,
	"./7_1_0.png": 176,
	"./7_1_1.png": 177,
	"./7_1_2.png": 178,
	"./7_1_3.png": 179,
	"./8_4_0.png": 180,
	"./8_4_1.png": 181,
	"./9_1_0.png": 182,
	"./9_1_1.png": 183,
	"./9_1_2.png": 184,
	"./9_1_3.png": 185,
	"./CardBack.png": 6,
	"./CardBlank.png": 12
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 4;